import { AdminUsersResponse, UserData, WebsiteStatsResponse, FunnelStats } from '../types';

const API_URL = 'https://canlii-pinpoint-api.thomoal.workers.dev';

export async function fetchUsers(password: string): Promise<AdminUsersResponse> {
  const response = await fetch(`${API_URL}/admin/users`, {
    headers: {
      'X-Admin-Secret': password,
    },
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Invalid password');
    }
    throw new Error('Failed to fetch users');
  }

  return response.json();
}

export async function updateUser(
  password: string,
  email: string,
  updates: Partial<Pick<UserData, 'subscribed' | 'plan' | 'messageCount' | 'similarCasesCount' | 'studentVerified' | 'name' | 'userType' | 'affiliate'>>
): Promise<UserData> {
  const response = await fetch(`${API_URL}/admin/users/${encodeURIComponent(email)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Admin-Secret': password,
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: 'Request failed' })) as { error: string };
    throw new Error(body.error || 'Failed to update user');
  }

  const data = await response.json() as { user: UserData };
  return data.user;
}

export async function deleteUser(password: string, email: string): Promise<void> {
  const response = await fetch(`${API_URL}/admin/users/${encodeURIComponent(email)}`, {
    method: 'DELETE',
    headers: {
      'X-Admin-Secret': password,
    },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: 'Request failed' })) as { error: string };
    throw new Error(body.error || 'Failed to delete user');
  }
}

export async function fetchWebsiteStats(password: string, days = 30): Promise<WebsiteStatsResponse> {
  const response = await fetch(`${API_URL}/admin/website-stats?days=${days}`, {
    headers: { 'X-Admin-Secret': password },
  });
  if (!response.ok) throw new Error('Failed to fetch website stats');
  return response.json();
}

export async function fetchFunnelStats(password: string): Promise<FunnelStats> {
  const response = await fetch(`${API_URL}/admin/funnel-stats`, {
    headers: { 'X-Admin-Secret': password },
  });
  if (!response.ok) throw new Error('Failed to fetch funnel stats');
  return response.json();
}
